($ => {

	const $frontPageHero = $('.home .hero');
	const $frontPageHeroSlides = $frontPageHero.find('.hero-slides');
	const $frontPageHeroSlideThumbnails = $frontPageHero.find('.hero-slideThumbnail');

	// Initialize the slideshow
	if( $frontPageHero.hasClass('slideshow') ) {
		$frontPageHeroSlides.slick({
			arrows: false,
			autoplay: true,
			autoplaySpeed: 5000
		});
	}
	// Initialize the typing
	else if( $frontPageHero.hasClass('typing') ) {
		window.currentString = -1; // Index of current string

		const $body = $frontPageHero.find('.hero-slide-body-typing');
		const strings = $body.data('strings');

		$body.typed({
			strings,
			typeSpeed: 50,
			startDelay: 500,
			backDelay: 3000,
			loop: true,
			preStringTyped: () => {
				window.currentString = window.currentString + 1 < strings.length ? window.currentString + 1 : 0;

				$('.hero-slide-body-accessible-string')
					.attr( 'aria-hidden', 'true' )
					.eq( window.currentString )
					.attr( 'aria-hidden', 'false' );
			}
		});
	}

	// Keep track of which slide is active
	const setActiveClass = ( currentSlide=0 ) => {
		$frontPageHeroSlideThumbnails
			.removeClass('active')
			.filter(`[data-slide="${currentSlide}"]`)
			.addClass('active')
	};

	setActiveClass();

	$frontPageHeroSlides.on( 'beforeChange', ( event, slick, currentSlide, nextSlide ) =>
		setActiveClass( nextSlide )
	);

	// Navigate to the selected slide
	const navigateToSlide = event => {
		const slide = parseInt( $( event.currentTarget ).data('slide') );

		$frontPageHeroSlides.one( 'afterChange', () =>
			$frontPageHeroSlides.find(`.hero-slide:not(.slick-cloned):eq(${slide})`).attr( 'aria-hidden', 'false' ).attr( 'tabindex', '0' ).get(0).focus()
		);

		$frontPageHeroSlides.slick( 'slickGoTo', slide );
	};

	$frontPageHeroSlideThumbnails.click( navigateToSlide );
	$frontPageHeroSlideThumbnails.keypress( event => event.keyCode == 13 ? navigateToSlide( event ) : null );

})(jQuery);



// WEBPACK FOOTER //
// ../benetech/js/components/hero.js